import CRUD from "@/firebase/crud";
import store from "@/store/index";
import { async } from "@firebase/util";

const Admin = {
  namespaced: true,
  state: {
    Portals: {},
    Documents: [],
    Document: null,
    DocumentResult: {},
    Sponsors: null,
    SponsorsResult: {},
    OtherDocuments: null,
    OtherDocumentsResult: {},
    DocByID: [],
    DocResultByID: {},
    SecondDocByID: [],
    SecondDocResultByID: {},
    GameByID: [],
    GameResultByID: {},
    Lookups: []
  },
  getters: {},
  mutations: {
    //documents
    setDocuments(state, data) {
      state.Documents = data;
    },
    setDocument(state, data) {
      state.Document = data;
    },
    setDocumentResult(state, data) {
      state.DocumentResult = data;
    },
    //doc by id
    setDocByID(state, data){
      state.DocByID = data;
    },
    setDocResultByID(state, data) {
      state.DocResultByID = data;
    },
    //second doc by id
    setSecondDocByID(state, data){
      state.SecondDocByID = data;
    },
    setSecondDocResultByID(state, data) {
      state.SecondDocResultByID = data;
    },
    //game by id
    setGameByID(state, data){
      state.GameByID = data;
    },
    setGameResultByID(state, data) {
      state.GameResultByID = data;
    },
    //sponsors
    setSponsors(state, data) {
      state.Sponsors = data;
    },
    setSponsorsResult(state, data) {
      state.SponsorsResult = data;
    },
    //portals
    setPortals(state, data) {
      state.Portals = data;
    },
    //lookups
    setLookups(state, data) {
      state.Lookups = data;
    },
    //for sponsors in GameReport.vue
    setOtherDocuments(state, data) {
      state.OtherDocuments = data;
    },
    setOtherDocumentsResult(state, data) {
      state.OtherDocumentsResult = data;
    },
  },
  actions: {
    createDocument: async ({ commit }, payload) => {
      // // console.log(commit);
      try {
        let Collection = payload[0];
        let Data = payload[1];
        // let Mutation = payload[2];
        let Result = Promise.resolve(CRUD.CreateDocument(Collection, Data));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "failure":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Admin/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    readDocuments: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(
          CRUD.ReadDocuments(Collection, portalID, null)
        );
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Admin/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    readSponsorPanel: async ({commit}, payload) => {
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(
          CRUD.ReadDocuments(Collection, portalID, null)
        );
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setSponsorsResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setSponsorsResult", Response.message);
              break;
            default:
              store.commit("Admin/setSponsorsResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    readOtherDocuments: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(
          CRUD.ReadDocuments(Collection, portalID, null)
        );
        //console.log("PAAAAYLOAD = " + JSON.stringify(payload, null, 2));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              // // console.log("SUCCESSSSSSSSSSSSSSSSSSS")
              // // console.log(Response)
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setOtherDocumentsResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setOtherDocumentsResult", Response.message);
              break;
            default:
              store.commit("Admin/setOtherDocumentsResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // store.commit("Admin/setDocumentResult", "Error");
        // console.log(err);
      }
    },
    updateDocument: async ({ commit }, payload) => {
      // // console.log(commit);
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let Data = payload[2];
        let Result = Promise.resolve(CRUD.UpdateDocument(Collection, ID, Data));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "failure":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Admin/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    deleteDocument: async ({ commit }, payload) => {
      // // console.log(commit);
      try {
        let Collection = payload[0];
        let ID = payload[1];
        // let Mutation = payload[2];
        let Result = Promise.resolve(CRUD.DeleteDocument(Collection, ID));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "failure":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Admin/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    readPortals: async ({ commit }) => {
      // // console.log(commit);
      try {
        let Collection = "portals";
        let Mutation = "Admin/setPortals";
        store.commit(Mutation, []);
        let Result = Promise.resolve(CRUD.readPortals(Collection));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Admin/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        store.commit("Admin/setDocumentResult", "Error");
      }
    },
    readLookups: async ({ commit }, payload) => {
      try {
        let portalID = payload[0];
        let Collection = "lookups";
        let Mutation = "Admin/setLookups";
        store.commit(Mutation, []);
        if (portalID !== undefined) {
          let Result = Promise.resolve(
            CRUD.ReadDocuments(Collection, portalID, null)
          );
          Result.then(Response => {
            switch (Response.result) {
              case "success":
                store.commit(Mutation, Response.data);
                break;
              case "failure":
                store.commit("Admin/setDocumentResult", Response.message);
                break;
              case "error":
                store.commit("Admin/setDocumentResult", Response.message);
                break;
              default:
                store.commit("Admin/setDocumentResult", Response.message);
                break;
            }
          });
        } else {
          // Return Nothing Emtpy Lookups
        }
      } catch (err) {
        store.commit("Admin/setDocumentResult", "Error");
      }
    },
    readDocumentByID: async ({commit}, payload) => {
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(
          CRUD.GetDocumentByID(Collection, ID)
        );
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setDocResultByID", Response.message);
              break;
            case "error":
              store.commit("Admin/setDocResultByID", Response.message);
              break;
            default:
              store.commit("Admin/setDocResultByID", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    readGameByID: async ({commit}, payload) => {
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(
          CRUD.GetDocumentByID(Collection, ID)
        );
        //console.log("Payload game = " + JSON.stringify(payload, null, 2));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setGameResultByID", Response.message);
              break;
            case "error":
              store.commit("Admin/setGameResultByID", Response.message);
              break;
            default:
              store.commit("Admin/setGameResultByID", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    }
  }
};

export default Admin;
